import { QueryParams } from './useQueryGroups';

export const groupKeys = {
  groups: (params?: QueryParams) => ['GROUPS', params] as const,
  single_group: (groupId: string) => ['SINGLE_GROUP', groupId],
};
